import React, { useEffect, useState } from 'react';
import { useTitle } from '../../Hooks';
import { Header, Pagination, Input, Button } from 'react-frontier';
import { User } from '../../Classes';
import { Card } from '../../components';
import { Link } from 'react-router-dom';
import moment from 'moment';
import classNames from 'classnames';
import API from '../../API';

const PAGE_SIZE = 10;

var Users = ()=>{
	var { setTitle } = useTitle();
	var [loadError, setLoadError] = useState<string>(null);
	var [searchQuery, setSearchQuery] = useState<string>(null);
	var [loading, setLoading] = useState<boolean>(false);
	var [users, setUsers] = useState<User []>(null);
	var [page, setPage] = useState<number>(0);

	useEffect(()=>{
		setTitle('Usuarios');
		getUsers();
	}, []);

	var getUsers = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;
	
		setLoading(true);
		API.usersList(searchQuery, offset, PAGE_SIZE).then(res=>{
			if(res.error) return setLoadError(res.message);

			setUsers(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado cargando los usuarios. (LCL-1)');
		}).finally(()=>{
			setLoading(false);
		})
	}

	var onPageChange = (page: number)=>{
		setPage(page);
		getUsers(page);
	}

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if(!users){
		return <Header loading text='Cargando datos' />;
	}
	
	return <div className='tp admin-users-screen'>
		<Input value={searchQuery} onChange={setSearchQuery} onSubmit={() => getUsers()} submitOnEnter button={
			<Button text='Buscar' onClick={() => getUsers()}/>
		}/>
		{loading ? (
			<Header text='Buscando' loading />
		) : users.length === 0 ? (
			<Header text='No se encontraron registros' iconName='sad-tear' style={{ marginTop: 50, marginBottom: 50 }}/>
		) : (
			users.map(a=>(
				<Card className='worker' image={a.image} imageFallbackIcon='image' key={`PSTWRK-${a.user_id}`} as={Link} to={`./${a.user_id}`}>
					<div className="left">
						<div className="name">{`${(a.first_name + ' ' + a.last_name).toUpperCase()}`}</div>
						<div className="meta">Creación: {moment.unix(a.date_created).format('DD/MMM/YY')}</div>
						<div className="info">
							<div className="info-item">
								<span className="label">Correo:</span>
								<span className="value">{a.email}</span>
							</div>
							{a.curp && <div className="info-item">
								<span className="label">CURP:</span>
								<span className="value">{a.curp}</span>
							</div>}
							{a.rfc && <div className="info-item">
								<span className="label">RFC:</span>
								<span className="value">{a.rfc}</span>
							</div>}
						</div>
					</div>
					<div className='right'>
						<div  className={classNames("fr label", {
							green: a.onboarded && !a.banned,
							yellow: !a.onboarded && !a.banned,
							red: a.banned
						})}>
							{a.banned ? 'Baneado' : a.onboarded ? 'Activo' : 'Inactivo'}
						</div>
					</div>
				</Card>
		)))}
		{users.length >= PAGE_SIZE || page !== 0 ? <div style={{ textAlign: 'center' }}>
			<Pagination page={page} onPageChange={onPageChange} />
		</div> : null}
	</div>
}

export default Users;